// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import router from './router'
import config from './modules/config'
import 'element-ui/lib/theme-chalk/index.css'
import VueQriously from 'vue-qriously'
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(VueQriously)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js